import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./auth/login/login.component";
import { CallbackComponent } from "./auth/callback/callback.component";
import { TenantComponent } from "./auth/tenant/tenant.component";
import { ErrorComponent } from "./auth/error/error.component";
import { MainComponent } from "./shared/main/main.component";
import { SignatureCreateComponent } from "./signatures/signature-create/signature-create.component";
import { SignatureDetailsComponent } from "./signatures/signature-details/signature-details.component";
import { SignatureEditComponent } from "./signatures/signature-edit/signature-edit.component";
import { WizardUnitComponent } from "./signatures/wizard/wizard-unit/wizard-unit.component";
import { WizardUserComponent } from "./signatures/wizard/wizard-user/wizard-user.component";
import { WizardComponent } from "./signatures/wizard/wizard.component";
import { WizardChooseComponent } from "./signatures/wizard/wizard-choose/wizard-choose.component";
import { WizardFinalComponent } from "./signatures/wizard/wizard-final/wizard-final.component";
import { WizzardSuccessComponent } from "./signatures/wizard/wizzard-success/wizzard-success.component";
import { PlannedComponent } from "./planned/planned.component";
import { TranslationsOnlyBlankComponent } from "./shared/blank/translations-only-blank.component";
import { PlanComponent } from "./plan/plan.component";
import { SubscriptionSuccessComponent } from "./plan/subscription-success/subscription-success.component";
import { SubscriptionFailedComponent } from "./plan/subscription-failed/subscription-failed.component";
import { FinanceComponent } from "./finance/finance.component";
import { AuthGuard } from "./auth/guard/auth.guard";
import { ClientComponent } from "./client/client.component";
import { ClientDetailComponent } from "./client/client-detail/client-detail.component";
import { ResellerComponent } from "./reseller/reseller.component";
import { EmployeeListComponent } from "./employees/employee-list/employee-list.component";
import { CurrentEmployeeFormComponent } from "./employees/current-employee-form/current-employee-form.component";
import { DigitalCardsComponent } from "./digital-cards/digital-cards.component";
import { DigitalCardsListComponent } from "./digital-cards/digital-cards-list/digital-cards-list.component";
import { DigitalCardEditorComponent } from "./digital-cards/digital-card-editor/digital-card-editor.component";
import { DigitalCardStatisticsComponent } from "./digital-cards/digital-card-statistics/digital-card-statistics.component";
import { DigitalCardCustomSourcesComponent } from "./digital-cards/digital-card-custom-sources/digital-card-custom-sources.component";
import { BackgroundComponent } from "./background/background.component";
import { BackgroundListComponent } from "./background/background-list/background-list.component";
import { MeetBackgroundListComponent } from "./meet-background/meet-background-list/meet-background-list.component";
import { MeetBackgroundEditorComponent } from "./meet-background/meet-background-editor/meet-background-editor.component";
import { BackgroundCreateComponent } from "./background/background-create/background-create.component";
import { BackgroundEditComponent } from "./background/background-edit/background-edit.component";
import { SettingsComponent } from "./settings/settings.component";
import { AddonsComponent } from "./addons/addons.component";
import { AccountsComponent } from "./accounts/accounts.component";
import { UserAdminsComponent } from "./user-admins/user-admins.component";
import { DomainsComponent } from "./domains/domains.component";
import { SignaturesComponent } from "./signatures/signatures.component";
import { MediaComponent } from "./media/media.component";
import { CompanyComponent } from "./company/company.component";
import { EmployeeSettingsComponent } from "./employee-settings/employee-settings.component";
import { BranchSettingsComponent } from "./branch-settings/branch-settings.component";
import { AdvancedSettingsComponent } from "./advanced-settings/advanced-settings.component";
import { IntegrationSettingsComponent } from "./integration-settings/integration-settings.component";
import { ExpiredTrialComponent } from "./expired-trial/expired-trial.component";
import { ExpiredTrialSuccessComponent } from "./expired-trial/succcess/success.component";
import { ExpiredTrialCancelComponent } from "./expired-trial/cancel/cancel.component";
import { SignaturesNavigationComponent } from "./signatures/signatures-navigation/signatures-navigation.component";
import { SignaturesPredefinedComponent } from "./signatures/signatures-predefined/signatures-predefined.component";
import { EditSignaturePredefinedComponent } from "./signatures/edit-signature-predefined/edit-signature-predefined.component";
import { AnalyticsDashboardComponent } from "./analytics-dashboard/analytics-dashboard.component";
import { ApiSettingsComponent } from "./api-settings/api-settings.component";
import { BillingComponent } from "./billing/billing.component";
import { BillingSettingsComponent } from "./billing/settings/billing-settings.component";
import { BillingSuccessComponent } from "./billing/success/success.component";
import { BillingCancelComponent } from "./billing/cancel/cancel.component";
import { ExtensionComponent } from "./extension/extension.component";
import { ExtensionAuthComponent } from "./auth/extension-auth/extension-auth.component";
import { GeneratorComponent } from "./generator/generator.component";
import { OnboardingComponent } from "./onboarding/onboarding.component";
import { StartComponent } from "./start/start.component";
import { CalculatorsComponent } from "./calculators/calculators.component";
import { WebinarComponent } from "./webinar/webinar.component";
import { EesiComponent } from "./eesi/eesi.component";
import { SubscriptionComponent } from "./subscription/subscription.component";
import { PublicSubscriptionComponent } from "./public-subscription/public-subscription.component";
import { NoAccessComponent } from "./no-access/no-access.component";
import { ExternalRedirectComponent } from "./external-redirect/external-redirect.component";
import { AuditLogComponent } from "./audit-log/audit-log.component";
import { PrintCardOrdersComponent } from "./print-card-orders/print-card-orders.component";
import { PrintCardOrderDetailComponent } from "./print-card-orders/print-card-order-detail/print-card-order-detail.component";
import { PrintCardsComponent } from "./print-cards/print-cards.component";
import { PrintCardsListComponent } from "./print-cards/print-cards-list/print-cards-list.component";
import { PrintCardVisualEditorComponent } from "./print-cards/print-card-visual-editor/print-card-visual-editor.component";
import { CardOrdersComponent } from "./card-orders/card-orders.component";
import { CardOrdersListComponent } from "./card-orders/card-orders-list/card-orders-list.component";
import { CardOrderCreateComponent } from "./card-orders/card-order-create/card-order-create.component";
import { CardOrderDetailComponent } from "./card-orders/card-order-detail/card-order-detail.component";

const routes: Routes = [
  {
    path: "login",
    component: TranslationsOnlyBlankComponent,
    children: [
      { path: "", component: LoginComponent },
      { path: "callback", component: CallbackComponent },
      { path: "extension", component: ExtensionAuthComponent },
      { path: "tenant", component: TenantComponent },
      { path: "error", component: ErrorComponent },
    ],
  },
  {
    path: "onboarding",
    component: OnboardingComponent,
  },
  {
    path: "calculators",
    component: CalculatorsComponent,
  },
  {
    path: "webinar",
    component: WebinarComponent,
  },
  {
    path: "webinar2",
    component: WebinarComponent,
  },
  {
    path: "eesi",
    component: EesiComponent,
  },
  {
    path: "public-subscription",
    component: PublicSubscriptionComponent,
  },
  {
    path: "plan",
    component: TranslationsOnlyBlankComponent,
    children: [
      { path: "", component: PlanComponent },
      { path: "success", component: SubscriptionSuccessComponent },
      { path: "fail", component: SubscriptionFailedComponent },
    ],
  },
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: MainComponent,
    children: [
      { path: "", redirectTo: "accounts", pathMatch: "full" },
      {
        path: "start",
        component: StartComponent,
        data: { managerRoute: true },
      },
      { path: "generator", component: GeneratorComponent },
      {
        path: "settings",
        component: SettingsComponent,
        data: { managerRoute: true },
        children: [
          { path: "", redirectTo: "company", pathMatch: "full" },
          { path: "company", component: CompanyComponent },
          { path: "employees", component: EmployeeSettingsComponent },
          { path: "departments", component: BranchSettingsComponent },
          { path: "advanced", component: AdvancedSettingsComponent },
          { path: "integration", component: IntegrationSettingsComponent },
          {
            path: "billing",
            component: BillingComponent,
            children: [
              { path: "", component: BillingSettingsComponent },
              { path: "success", component: BillingSuccessComponent },
              { path: "cancel", component: BillingCancelComponent },
            ],
          },
          { path: "api", component: ApiSettingsComponent },
          {
            path: "api/:sectionId/:endpointId",
            component: ApiSettingsComponent,
          },
          { path: "extension", component: ExtensionComponent },
        ],
      },
      { path: "no-access", component: NoAccessComponent },

      {
        path: "signatures",
        component: SignaturesNavigationComponent,
        data: { managerRoute: true },
        children: [
          { path: "", redirectTo: "custom", pathMatch: "full" },
          { path: "custom", component: SignaturesComponent },
          { path: "custom/create", component: SignatureCreateComponent },
          { path: "library", component: SignaturesPredefinedComponent },
          { path: "library/new", component: EditSignaturePredefinedComponent },
          {
            path: "library/:templatePredefinedId",
            component: EditSignaturePredefinedComponent,
          },
          { path: "custom/create", component: SignatureCreateComponent },
          {
            path: "custom/:templateId/edit",
            component: SignatureEditComponent,
          },
          {
            path: "custom/:templateId",
            component: SignatureDetailsComponent,
          },
        ],
      },

      {
        path: "media",
        component: MediaComponent,
        data: { managerRoute: true },
      },
      {
        path: "digital-cards",
        component: DigitalCardsComponent,
        data: { managerRoute: true },
        children: [
          {
            path: "",
            component: DigitalCardsListComponent,
            data: { managerRoute: true },
          },
          {
            path: "statistics",
            component: DigitalCardStatisticsComponent,
            data: { managerRoute: true },
          },
          {
            path: "sources",
            component: DigitalCardCustomSourcesComponent,
            data: { managerRoute: true },
          },
          {
            path: "custom-sources",
            redirectTo: "sources",
            pathMatch: "full",
          },
          {
            path: "create",
            component: DigitalCardEditorComponent,
            data: { managerRoute: true },
          },
          {
            path: ":profileId/edit",
            component: DigitalCardEditorComponent,
            data: { managerRoute: true },
          },
          {
            path: ":profileId/statistics",
            component: DigitalCardStatisticsComponent,
          },
        ],
      },
      {
        path: "print-cards",
        component: PrintCardsComponent,
        data: { managerRoute: true },
        children: [
          {
            path: "",
            component: PrintCardsListComponent,
            data: { managerRoute: true },
          },
          {
            path: "create",
            component: PrintCardVisualEditorComponent,
            data: { managerRoute: true, superAdminRoute: true },
          },
          {
            path: ":printCardTemplateId/edit",
            component: PrintCardVisualEditorComponent,
            data: { managerRoute: true, superAdminRoute: true },
          },
        ],
      },
      {
        path: "card-orders",
        component: CardOrdersComponent,
        children: [
          {
            path: "",
            component: CardOrdersListComponent,
          },
          {
            path: "create",
            component: CardOrderCreateComponent,
          },
          {
            path: ":printCardOrderId",
            component: CardOrderDetailComponent,
          },
        ],
      },
      {
        path: "backgrounds",
        component: BackgroundComponent,
        data: { managerRoute: true },
        children: [
          {
            path: "meets",
            component: MeetBackgroundListComponent,
            data: { managerRoute: true },
          },
          {
            path: "meets/create",
            component: MeetBackgroundEditorComponent,
            data: { managerRoute: true },
          },
          {
            path: "meets/:meetBackgroundId/edit",
            component: MeetBackgroundEditorComponent,
            data: { managerRoute: true },
          },
          {
            path: "",
            component: BackgroundListComponent,
            data: { managerRoute: true },
          },
          {
            path: "create",
            component: BackgroundCreateComponent,
            data: { managerRoute: true },
          },
          {
            path: ":backgroundId/edit",
            component: BackgroundEditComponent,
            data: { managerRoute: true },
          },
        ],
      },
      {
        path: "my-digital-cards",
        component: DigitalCardsListComponent,
        data: { readOnly: true },
      },
      {
        path: "my-backgrounds",
        component: BackgroundListComponent,
        data: { readOnly: true },
      },
      {
        path: "my-digital-cards/:profileId/statistics",
        component: DigitalCardStatisticsComponent,
      },
      {
        path: "signatures",
        redirectTo: "signatures/custom",
        pathMatch: "full",
      },
      {
        path: "signatures/create",
        redirectTo: "signatures/custom/create",
        pathMatch: "full",
      },
      {
        path: "signatures/:templateId/edit",
        redirectTo: "signatures/custom/:templateId/edit",
        pathMatch: "full",
      },
      {
        path: "signatures/:templateId",
        redirectTo: "signatures/custom/:templateId",
        pathMatch: "full",
      },
      {
        path: "planned",
        component: PlannedComponent,
        data: { managerRoute: true },
      },
      {
        path: "finance",
        component: FinanceComponent,
        data: { managerRoute: true },
      },
      {
        path: "employees",
        component: EmployeeListComponent,
        data: { managerRoute: true },
      },
      { path: "my-account", component: CurrentEmployeeFormComponent },
      {
        path: "addons",
        component: AddonsComponent,
        data: { managerRoute: true },
      },
      { path: "accounts", component: AccountsComponent },
      {
        path: "wizard",
        component: WizardComponent,
        data: { managerRoute: true },
        children: [
          { path: "", component: WizardChooseComponent },
          { path: "group", component: WizardUnitComponent },
          { path: "user", component: WizardUserComponent },
          { path: "final", component: WizardFinalComponent },
          { path: "success", component: WizzardSuccessComponent },
        ],
      },
      { path: "user-admins", component: UserAdminsComponent },
      {
        path: "domains",
        component: DomainsComponent,
        data: { managerRoute: true },
      },
      {
        path: "stats",
        component: AnalyticsDashboardComponent,
        data: { managerRoute: true },
      },
      {
        path: "subscription",
        component: SubscriptionComponent,
        data: { managerRoute: true },
      },
    ],
  },
  {
    path: "admin",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { adminRoute: true },
    component: MainComponent,
    children: [
      { path: "audit-log", component: AuditLogComponent },
      { path: "print-card-orders", component: PrintCardOrdersComponent },
      {
        path: "print-card-orders/:printCardOrderId",
        component: PrintCardOrderDetailComponent,
      },
      { path: "client", component: ClientComponent },
      { path: "client/:clientId", component: ClientDetailComponent },
      { path: "reseller", component: ResellerComponent },
    ],
  },
  {
    path: "expired-trial",
    component: MainComponent,
    children: [
      { path: "", component: ExpiredTrialComponent },
      { path: "success", component: ExpiredTrialSuccessComponent },
      { path: "cancel", component: ExpiredTrialCancelComponent },
    ],
  },
  {
    path: "lukasz",
    component: ExternalRedirectComponent,
  },
  {
    path: "**",
    redirectTo: "login",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
